import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { environment } from "../environment/environments";

const apiRoute = "/api/";

let token = "";
let orgId = "";
let userId = "";
let programId = "";

const setTokenValues = () => {
  token = `user ${localStorage.getItem("token")}`;
  orgId = localStorage.getItem("orgId");
  userId = localStorage.getItem("userId");
  programId = localStorage.getItem("pid");
}

export const getAllMentors = createAsyncThunk(
    "mentee/getAllMentors",
    async ({search, experience}, thunkAPI) => {
      try {
        setTokenValues();
        const title = search ?? "";
        const xp = experience ?? "";
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            orgId +
            `/getAllUsers/mentor?title=${title}&xp=${xp}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );


export const getAllUsersByProgram = createAsyncThunk(
    "mentee/getAllUsersByProgram",
    async ({search, experience, topic, interest, index}, thunkAPI) => {
      try {
        setTokenValues();
        const page = index ?? "";
        const title = search ?? "";
        const xp = experience ?? "";
        const exp = topic ?? "";
        const int = interest ?? "";

        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            programId +
            `/getAllUsersByProgram/mentor?page=${page}&title=${title}&xp=${xp}&exp=${exp}&int=${int}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

export const getParticularUser = createAsyncThunk(
    "mentee/getParticularUser",
    async ({user, userId}, thunkAPI) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            "getParticularUser/" + 
            user + 
            "/" + 
            userId,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const getMentorAvailableDates = createAsyncThunk(
    "admin/getMentorAvailableDates",
    async ({userId, date}, thunkAPI) => {
      try {
        setTokenValues();
        const ate = date ?? "";
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            userId +
            `/getMentorAvailableDates?date=${ate}` ,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

export const getMentorSlotsByDate = createAsyncThunk(
    "admin/getMentorSlotsByDate",
    async ({userId, date}, thunkAPI) => {
      try {
        setTokenValues();
        const response = await fetch(
            environment.baseURL + 
            apiRoute +
            userId +
            "/getMentorSlotsByDate/" +
            date ,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token
            },
          }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        
        if (response.status === 200) {
          return data.Data;
        } else {
          return thunkAPI.rejectWithValue(data);
        }
      } catch (e) {
        thunkAPI.rejectWithValue(e.response.data);
      }
    }
  );

  export const getUpcomingInterviewDetails = createAsyncThunk("mentee/getUpcomingInterviewDetails", async ({search, date, index} ,thunkAPI) => {
    try {
        setTokenValues();
        const title = search ?? "";
        const ate = date ?? "";
        const page = index ?? "";

        const response = await fetch(environment.baseURL +
            apiRoute +
            userId + `/getUpcomingInterviewDetails/mentee?title=${title}&ate=${ate}&page=${page}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        );
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data.Data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

export const getPastInterviewDetails = createAsyncThunk("mentee/getPastInterviewDetails", async ({search, date, status, index}, thunkAPI) => {
    try {
        setTokenValues();
        const title = search ?? "";
        const ate = date ?? "";
        const ss = status ?? "";
        const page = index ?? "";

        const response = await fetch(environment.baseURL +
            apiRoute +
            userId + `/getPastInterviewDetails/mentee?title=${title}&ate=${ate}&ss=${ss}&page=${page}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: token,
                },
            }
        );
        let data = await response.json();
        if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
        if (response.status === 200) {
            return data.Data;
        } else {
            return thunkAPI.rejectWithValue(data);
        }
    } catch (error) {
        return thunkAPI.rejectWithValue({ error: error.message });
    }
}
);

export const getUserFeedback = createAsyncThunk("mentee/getUserFeedback", async (feedbackId, thunkAPI) => {
  try {
      setTokenValues();

      const response = await fetch(environment.baseURL +
          apiRoute +
          userId +
          "/booking/" +
          feedbackId + 
          "/getUserFeedback/mentee",
          {
              method: "GET",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data.Data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const updateUserDetails = createAsyncThunk("mentee/updateUserDetails", async (obj, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "updateUserDetails",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify(obj)
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const resheduleInterview = createAsyncThunk("mentee/resheduleInterview", async ({slotId, obj}, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          slotId +
          "/resheduleInterview",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify(obj)
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const bookMentorSlot = createAsyncThunk("mentee/bookMentorSlot", async ({slotId, agenda}, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          slotId +
          "/bookMentorSlot",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify({agenda})
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const saveUserFeedbackAnswers = createAsyncThunk("mentor/saveUserFeedbackAnswers", async ({feedbackId, obj}, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          "booking/" +
          feedbackId +
          "/saveUserFeedbackAnswers/mentee",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify(obj)
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const cancelInterview = createAsyncThunk("mentee/cancelInterview", async ({slotId, reason}, thunkAPI) => {
  try {
      setTokenValues();
      const response = await fetch(environment.baseURL +
          apiRoute +
          slotId +
          "/cancelInterview",
          {
              method: "POST",
              headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: token,
              },
              body: JSON.stringify({reason})
          }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      if (response.status === 200) {
          return data;
      } else {
          return thunkAPI.rejectWithValue(data);
      }
  } catch (error) {
      return thunkAPI.rejectWithValue({ error: error.message });
  }
}
);

export const changePassword = createAsyncThunk(
  "mentee/changePassword",
  async (obj, thunkAPI) => {
    try {
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          "changePassword",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(obj),
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getInterestsAndTopics = createAsyncThunk(
  "admin/getInterestsAndTopics",
  async ( thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getInterestsAndTopics",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          }
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data?.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMenteeCallsActivity = createAsyncThunk(
  "admin/getMenteeCallsActivity",
  async ( thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getMenteeCallsActivity/" +
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getMenteePerformance = createAsyncThunk(
  "admin/getMenteePerformance",
  async ( thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getMenteePerformance/" +
          userId,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const getTopRatedMentors = createAsyncThunk(
  "admin/getTopRatedMentors",
  async ( thunkAPI ) => {
    try {
      setTokenValues();
      const response = await fetch(
          environment.baseURL + 
          apiRoute +
          programId +
          "/getTopRatedMentors",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token
          },
        }
      );
      let data = await response.json();
      if (response.statusText === 'Unauthorized') {
            localStorage.clear();
            window.location.reload();
        }
      
      if (response.status === 200) {
        return data.Data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (e) {
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

  export const menteeSlice = createSlice({
    name: "mentee",
    initialState: {
      isFetching: false,
      isMentorsFetching: false,
      isTopMentorFetching: false,
      isDashboardFetching: false,
      isSlotDatesFetching: false,
      isSlotsFetching: false,
      isBookingCall: false,
      isPerformanceFetching: false,
      isSuccess: false,
      isUserAddedSuccess: false,
      isError: false,
      errorMessage: "",
      allMentors: [],
      particularUser: [],
      mentorSlotDates: [],
      mentorSlots: [],
      upcomingCalls: [],
      pastCalls: [],
      interestTopics: [],
      feedback: {},
      menteeCallsData: [],
      menteePerformance: [],
      topRatedMentors: [],
      token: localStorage.getItem('token') ? localStorage.getItem('token') : null,
    },
    reducers: {
      clearState: (state) => {
        state.isError = false;
        state.errorMessage = "";
        state.isSuccess = false;
        state.isFetching = false;
        state.isMentorsFetching = false;
        state.isTopMentorFetching = false;
        state.isDashboardFetching = false;
        state.isSlotDatesFetching = false;
        state.isSlotsFetching = false;
        state.isBookingCall = false;
        state.isPerformanceFetching = false;
        state.isUserAddedSuccess = false;
        return state;
      },
      clearSlots: (state) => {
        state.mentorSlots = [];
        return state;
      },
      clearMentors: (state) => {
        state.allMentors = [];
        return state;
      },
    },
    extraReducers: (builder) => {
      builder.addCase(getAllMentors.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getAllMentors.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.allMentors = payload;
      });
      builder.addCase(getAllMentors.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getAllUsersByProgram.pending, (state) => {
          state.isMentorsFetching = true;
      });
      builder.addCase(getAllUsersByProgram.fulfilled, (state, { payload }) => {
          state.isMentorsFetching = false;
          state.allMentors = payload;
      });
      builder.addCase(getAllUsersByProgram.rejected, (state, {payload}) => {
          state.isMentorsFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getParticularUser.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getParticularUser.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.particularUser = payload;
      });
      builder.addCase(getParticularUser.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMentorAvailableDates.pending, (state) => {
          state.isSlotDatesFetching = true;
      });
      builder.addCase(getMentorAvailableDates.fulfilled, (state, { payload }) => {
          state.isSlotDatesFetching = false;
          state.mentorSlotDates = payload;
      });
      builder.addCase(getMentorAvailableDates.rejected, (state, {payload}) => {
          state.isSlotDatesFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMentorSlotsByDate.pending, (state) => {
          state.isSlotsFetching = true;
      });
      builder.addCase(getMentorSlotsByDate.fulfilled, (state, { payload }) => {
          state.isSlotsFetching = false;
          state.mentorSlots = payload;
      });
      builder.addCase(getMentorSlotsByDate.rejected, (state, {payload}) => {
          state.isSlotsFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getUpcomingInterviewDetails.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getUpcomingInterviewDetails.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.upcomingCalls = payload;
      });
      builder.addCase(getUpcomingInterviewDetails.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getInterestsAndTopics.pending, (state) => {
          // state.isFetching = true;
      });
      builder.addCase(getInterestsAndTopics.fulfilled, (state, { payload }) => {
          // state.isFetching = false;
          state.interestTopics = payload;
      });
      builder.addCase(getInterestsAndTopics.rejected, (state, {payload}) => {
          // state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getPastInterviewDetails.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(getPastInterviewDetails.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.pastCalls = payload;
      });
      builder.addCase(getPastInterviewDetails.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getUserFeedback.pending, (state) => {
          state.isLoaderFetching = true;
      });
      builder.addCase(getUserFeedback.fulfilled, (state, { payload }) => {
          state.isLoaderFetching = false;
          state.feedback = payload;
      });
      builder.addCase(getUserFeedback.rejected, (state, {payload}) => {
          state.isLoaderFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(updateUserDetails.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(updateUserDetails.fulfilled, (state) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(updateUserDetails.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(resheduleInterview.pending, (state) => {
          state.isLoaderFetching = true;
      });
      builder.addCase(resheduleInterview.fulfilled, (state) => {
          state.isLoaderFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(resheduleInterview.rejected, (state, {payload}) => {
          state.isLoaderFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(cancelInterview.pending, (state) => {
          state.isLoaderFetching = true;
      });
      builder.addCase(cancelInterview.fulfilled, (state) => {
          state.isLoaderFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(cancelInterview.rejected, (state, {payload}) => {
          state.isLoaderFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(bookMentorSlot.pending, (state) => {
          state.isBookingCall = true;
      });
      builder.addCase(bookMentorSlot.fulfilled, (state) => {
          state.isBookingCall = false;
          state.isSuccess = true;
      });
      builder.addCase(bookMentorSlot.rejected, (state, {payload}) => {
          state.isBookingCall = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(saveUserFeedbackAnswers.pending, (state) => {
          state.isFetching = true;
      });
      builder.addCase(saveUserFeedbackAnswers.fulfilled, (state) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(saveUserFeedbackAnswers.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(changePassword.pending, (state) => {
        state.isFetching = true;
      });
      builder.addCase(changePassword.fulfilled, (state, { payload }) => {
          state.isFetching = false;
          state.isSuccess = true;
      });
      builder.addCase(changePassword.rejected, (state, {payload}) => {
          state.isFetching = false;
          state.isError = true;
          state.errorMessage = payload.Message ?? "Something went wrong!";
      });
      builder.addCase(getMenteeCallsActivity.pending, (state) => {
        state.isDashboardFetching = true;
      });
      builder.addCase(getMenteeCallsActivity.fulfilled, (state, { payload }) => {
          state.isDashboardFetching = false;
          state.menteeCallsData = payload;
      });
      builder.addCase(getMenteeCallsActivity.rejected, (state, {payload}) => {
          state.isDashboardFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getMenteePerformance.pending, (state) => {
        state.isPerformanceFetching = true;
      });
      builder.addCase(getMenteePerformance.fulfilled, (state, { payload }) => {
          state.isPerformanceFetching = false;
          state.menteePerformance = payload;
      });
      builder.addCase(getMenteePerformance.rejected, (state, {payload}) => {
          state.isPerformanceFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
      builder.addCase(getTopRatedMentors.pending, (state) => {
        state.isTopMentorFetching = true;
      });
      builder.addCase(getTopRatedMentors.fulfilled, (state, { payload }) => {
          state.isTopMentorFetching = false;
          state.topRatedMentors = payload;
      });
      builder.addCase(getTopRatedMentors.rejected, (state, {payload}) => {
          state.isTopMentorFetching = false;
          state.isError = true;
          state.errorMessage = payload?.Message ?? "Something went wrong!";
      });
    },
  });
  
  
  export const { clearState } = menteeSlice.actions;
  export const { clearSlots } = menteeSlice.actions;
  export const { clearMentors } = menteeSlice.actions;
  
  export const menteeData = (state) => state.mentee;